import i18next from 'i18next';
import BotActivitiesLogo from '../../../../../components/Shared/Icons/BotActivitiesLogo';
import permissions from '../../../../permissions';
import BotActivities from '../../../../../components/BotActivities/List';

// const BOT_ACTIVITY_ROUTE_LIST_DS = {
//   path: '/:currentAccountUuid/accounts/:accountUuid/botActivity',
//   exact: true,
//   additional: {
//     component: BotActivities,
//     protected: true,
//     title: i18next.t('titles:botActivities'),
//     icon: BotActivitiesLogo,
//     permission: permissions.ADMIN_PATIENT_IMPORT,
//   },
// };

const BOT_ACTIVITY_ROUTE_LIST = {
  path: '/:currentAccountUuid/botActivity',
  exact: true,
  additional: {
    component: BotActivities,
    protected: true,
    title: i18next.t('titles:botActivities'),
    icon: BotActivitiesLogo,
    permission: permissions.ADMIN_PATIENT_IMPORT,
  },
};

export const BOT_ACTIVITY_ROUTES = {
  // ------- For child accounts ------
  // listDS: BOT_ACTIVITY_ROUTE_LIST_DS,

  // ------- For current accounts ------
  list: BOT_ACTIVITY_ROUTE_LIST,
};

